import { createBrowserRouter } from "react-router";
import App from "../App";
import AdminAuth from "../components/AdminAuth";
import { AdminAuthProvider } from "../components";
import AdminRoleGuard from "../components/AdminRoleGuard";

export const router = createBrowserRouter([
  {
    path: "/admin",
    children: [
      {
        element: (
          <AdminAuthProvider>
            <AdminAuth />
          </AdminAuthProvider>
        ),
        children: [
          {
            index: true,
            element: (
              <AdminRoleGuard allowedRoles={["Admin"]}>
                <App />
              </AdminRoleGuard>
            ),
          },
        ],
      },
    ],
  },
]);